var cell_default = {
  "cell": "ARoJI",
  "header": "_0aym2",
  "selected": "fLraD",
  "editing": "GsHPe",
  "singleSelection": "yzOYB",
  "hideLastBlock": "_2LgiW",
  "editorWrapper": "OMbdu",
  "viewerWrapper": "nWjZr",
  "hideFirstBlock": "xSPDS",
  "editor": "CiKrO",
  "edit": "qkL0z",
  "view": "_7ANKv",
  "editingToolbarWrapper": "CSLT3",
  "selectAll": "wnyKF",
  "disableSelection": "FYukG"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
